// extracted by mini-css-extract-plugin
module.exports =  {"value-change":"_02712f2b3b--value-change--yMNQ4","icon--inner":"_02712f2b3b--icon--inner--XMM_U","tooltip":"_02712f2b3b--tooltip--pD5xJ"};